import { css } from '@emotion/core';
export var container = {
  name: "716m51",
  styles: "margin:16px;.domain-radio__label{margin-bottom:19px;}"
};